// extracted by mini-css-extract-plugin
export default {"active":"ItemDetail_active__7jlUc","detail":"ItemDetail_detail__z9P6F","info":"ItemDetail_info__SkunB"};